// extracted by mini-css-extract-plugin
export default {"modify_order_header":"Ux","center":"Vx","empty":"Wx","pending":"Xx","referralTitle":"Yx","wrapper":"Zx","title":"ay","tabs":"by","tab":"cy","active":"ey","btn":"fy","rewards_table":"gy"};
    if(module.hot) {
      // 1714422955994
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  